import BoardScreen from "@/pages/BoardScreen";

const SEED = [
    { name: "Group 1", color: "#FF5500" },
    { name: "Group 2", color: "#2979FF" },
    { name: "Backlog", color: "#B0B0B0" },
];

export default function DevPlan() {
    return (
        <BoardScreen
            board="dev-plan"
            code="AO/01"
            title="Development Plan"
            subtitle="Engineering roadmap, sprints, blockers."
            seedGroups={SEED}
        />
    );
}
